import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialogModule as MatDialogModule
} from '@angular/material/legacy-dialog';
import { LocalStorageService } from '../../../app/connectors/localstorage';
import { RequesSetupService } from '../../../app/services/request-setup.service';
import { FormControl, Validators, FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { ViewDetailsLoaderComponent } from '../view-details-loader/view-details-loader.component';
import { ModalSuccessComponent } from '../modal-success/modal-success.component';
import Swal from 'sweetalert2';
import { UsersService } from '../../../app/services/users.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { NgFor, NgIf, NgClass } from '@angular/common';
interface Field {
  title: string;
  value: string;
}
interface Select {
  title: string;
  selectedOption: string;
}
@Component({
  selector: 'app-modal-new-request-type',
  templateUrl: './modal-new-request-type.component.html',
  styleUrls: ['./modal-new-request-type.component.css'],
  standalone: true,
  imports: [
    NgFor,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    NgIf,
    MatOptionModule,
    NgClass,
    MatInputModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class ModalNewRequestTypeComponent implements OnInit {
  email = new FormControl('', [Validators.required, Validators.email]);
  creationDate: any;
  createdBy: any;
  roleAcess: any;
  action: any;
  editMode: boolean = false;
  modalClose = new Subject<boolean>();
  optionsSelected: any;
  isSelectFilled: boolean = false;
  isInputFilled: boolean = false;
  owners: any;

  selectPriority: any = '';
  selectIcon: any = '';
  selectText: any = '';

  requestNameError: string = '';

  constructor(
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private serviceLocalStorage: LocalStorageService,
    private requestService: RequesSetupService,
    private userService: UsersService
  ) {
    this.modalClose = new Subject<boolean>();
  }
  async ngOnInit(): Promise<void> {
    this.getRoleAcess();
  }
  getRoleAcess() {
    this.roleAcess = this.serviceLocalStorage.decryptAndGet('roles-access');
  }
  closeDialog() {
    this.dialogRef.close();
  }
  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }
  edit(edit: any) {
    if (edit.title.toLowerCase() !== 'save') {
    } else if (edit.title.toLowerCase() === 'cancel') {
      this.closeDialog();
    }
  }
  compareAcess(req: any): boolean {
    if (req[0].toLowerCase() === 'none') {
      return false;
    }
    if (req[0].toLowerCase() !== this.roleAcess[0].toLowerCase()) {
      return true;
    }
    return false;
  }
  updateDisabled(obj: any, state: boolean) {
    if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (key === 'disabled' && obj['type'] !== 'flag') {
            obj[key] = state;
          } else {
            this.updateDisabled(obj[key], state);
          }
        }
      }
    }
  }
  alertsSweet(action: any) {
    this.actionEdit(action);
  }
  actionEdit(action: any) {
    if (action.title.toLowerCase() === 'cancel') {
      this.data.modal.fields.forEach((field: any) => {
        field.value = [''];
      });
      this.closeDialog();
    } else if (
      action.type.toLowerCase() === 'save-team' ||
      action.type.toLowerCase() === 'save-role' ||
      action.type.toLowerCase() === 'create-team' ||
      action.type.toLowerCase() === 'create-role' ||
      action.type.toLowerCase() === 'create-priority' ||
      action.type.toLowerCase() === 'save-request'
    ) {
      const fieldToBodyMap = this.getFieldToBodyMap(action.type.toLowerCase());
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap, action);
    }
  }
  getFieldToBodyMap(type: any): { [fieldKey: string | number]: string | number } {
    switch (type) {
      case 'save-team':
      case 'save-role':
      case 'create-role':
        return { roleName: 'Role Name' };
      case 'create-user':
        return { userName: 'User Name', emailAddress: 'Email Address', shortName: 'Short Name' };
      case 'create-priority':
        return { priorityName: 'Priority Name' };
      case 'create-team':
        return { requestName: 'Request Name', teamId: 'Team Name', shortName: 'Short Name' };
      case 'save-request':
        return {
          estimatedDeadline: 'Estimated Deadline',
          priorityId: 'Priorities',
          requestName: 'Request Name',
          shortName: 'Short Name',
          teamId: 'Team Id',
          teamName: 'Team Name'
        };
      default:
        return {};
    }
  }
  async save(path: any, body: any, fieldToBodyMap: { [fieldKey: string | number]: string | number }, actionType?: any) {
    if (this.data.modal.fields.some((field: any) => !field.value)) {
      return;
    }

    await this.openProgressDialog('Creating. Please wait');
    for (const fieldKey in fieldToBodyMap) {
      if (fieldToBodyMap.hasOwnProperty(fieldKey)) {
        const field = this.data.modal.fields.find((field: any) => field.title === fieldToBodyMap[fieldKey]);
        const select = this.data.modal.select.find((field: any) => field.title === fieldToBodyMap[fieldKey]);

        if (field) {
          if (field.title === 'Short Name' && field.value) {
            body[fieldKey] = field.value.toUpperCase();
          } else {
            body[fieldKey] = field.value;
          }
        } else if (select) {
          body[fieldKey] = this.optionsSelected;
        }
      }
    }
    if (actionType.type.toLowerCase() === 'create-team') {
      if (this.checkShortNameExists(body)) {
        this.errorUser();
        this.fecharModal();
        return;
      } else {
        body.createdBy = this.data.modal.idUser;
        this.actionSetup(path, body);
      }
    } else if (actionType.type.toLowerCase() === 'save-request') {
      let fields = this.data.modal.fields.reduce((obj: { [key: string]: string }, field: Field) => {
        obj[field.title] = field.value;
        return obj;
      }, {});

      let selects = this.data.modal.select.reduce((obj: { [key: string]: string }, select: Select) => {
        obj[select.title] = select.selectedOption;
        return obj;
      }, {});

      body.createdBy = this.data.modal.idUser;
      body.estimatedDeadline = fields['Estimated Deadline'];
      body.priorityId = selects['Priorities'];
      body.requestName = fields['Request Name'];
      body.shortName = fields['Short Name'];
      body.teamId = selects['Team Name'];
      body.requestOwnerId = selects['Process Owner'];
      this.actionSetup(path, body);
    } else {
      body.createdBy = this.data.modal.idUser;
      this.actionSetup(path, body);
    }
  }
  checkShortNameExists(body: any): boolean {
    if (!body || !body.shortName || !this.data.shortName) {
      return false;
    }
    const shortNameExists = this.data.shortName.some((shortName: any) => {
      return shortName?.toString().toLowerCase() === body?.shortName.toString().toLowerCase();
    });
    return shortNameExists;
  }

  isShortNameValid(): boolean {
    const shortNameField = this.data.modal.fields.find((field: any) => field.title === 'Short Name');
    return !shortNameField || shortNameField.value?.length === 3;
  }

  actionSetup(path: any, body: any) {
    this.requestNameError = '';
    this.requestService.actionSetup(path, body).subscribe({
      next: () => {
        this.data.modal.fields.forEach((field: any) => {
          field.value = [''];
        });
        this.data.modal.select.forEach((select: any) => {
          select.selectedOption = [''];
        });
        this.fecharModal();
        this.sweetAlert();
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 409) {
          this.requestNameError = error.error.message;
        } else {
          this.showErrorModal();
        }
        this.fecharModal();
      }
    });
  }
  openProgressDialog(text: any): Promise<void> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ViewDetailsLoaderComponent, {
        autoFocus: false,
        closeOnNavigation: true,
        disableClose: true,
        height: '250px',
        width: '600px',
        panelClass: 'center-modal',
        data: { modalClose$: this.modalClose, text: text }
      });
      dialogRef.afterOpened().subscribe(() => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    });
  }
  sweetAlert() {
    Swal.fire({
      title: 'Success!',
      text: 'Your informations has been saved.',
      icon: 'success',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085D6'
    }).then((result) => {
      this.closeDialog();
    });
  }
  openSuccessModal() {
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      autoFocus: false,
      closeOnNavigation: true,
      disableClose: true,
      height: '250px',
      width: '700px',
      panelClass: 'center-modal'
    });
    dialogRef.afterOpened().subscribe(() => {});
  }
  showErrorModal() {
    Swal.fire({
      title: 'Error',
      text: 'Something went wrong!\nPlease, try again in a moment.',
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085D6',
      customClass: 'custom-swal-error',
      footer:
        '<i class="icon-support"></i><a href="mailto:AM.US.OM.BusinessSolutions@global.ntt">click here to contact the support</a>'
    });
  }
  fecharModal() {
    this.modalClose.next(true);
  }
  onValueChange(optionSelected: any, title: any) {
    this.optionsSelected = optionSelected;
    if (title.toLowerCase() === 'team name') {
      this.processOwner(this.optionsSelected);
    }
  }
  processOwner(id: any) {
    this.userService.processOwner(id).subscribe((resp) => {
      this.owners = resp;
    });
  }

  onSelectChange() {
    this.isSelectFilled = !!this.data.modal.select.find((select: any) => !!select.selectedOption);
  }

  onInputChange() {
    this.isInputFilled = !!this.data.modal.fields.find((field: any) => !!field.value);
  }
  isFormValid() {
    const selectFilled = this.data.modal.select.every((select: any) => !!select.selectedOption);
    const inputFilled = this.data.modal.fields.every((field: any) => !!field.value);
    return selectFilled && inputFilled;
  }
  reset(result: any) {
    this.dialogRef.close(result);
  }
  formatarId(field: string): string {
    return field.replace(/\s+/g, '-').toLowerCase();
  }

  changePriority(row: any) {
    if (row.value) {
      this.selectPriority = row.value;
      this.selectIcon = row.icon;
      this.selectText = row.label;
    }
  }
  errorUser() {
    Swal.fire({
      title: 'Error',
      text: 'This short description already exists. \nPlease choose a different characters.',
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085D6',
      customClass: 'custom-swal-error',
      footer:
        '<i class="icon-support"></i><a href="mailto:AM.US.OM.BusinessSolutions@global.ntt">click here to contact the support</a>'
    }).then(() => {});
  }
}
